import React from 'react'
import { useMatch } from '@reach/router'
import {
  NavigationWrapper,
  NavigationLinkTitle,
  NavigationLink,
} from './Navigation.styles'
import menu from '../../data/menu'
import Icon from '../Icon'

{
  /* <NavigationWrapper initialPose={mobile ? 'exit' : 'enter'} pose="enter"> */
}
const Navigation = () => (
  <NavigationWrapper>
    {Object.values(menu).map((item) => (
      <NavigationLink
        to={item.path}
        key={item.path}
        current={useMatch(item.path)}
      >
        <Icon icon={item.icon} type={item.iconType} />
        <NavigationLinkTitle>{item.title}</NavigationLinkTitle>
      </NavigationLink>
    ))}
  </NavigationWrapper>
)

export default Navigation

// const config = {
//   enter: {
//     opacity: 1,
//     y: 0,
//     transition: {
//       default: () => ({
//         duration: 500,
//       }),
//     },
//   },
//   exit: {
//     opacity: 0,
//     y: 100,
//     transition: {
//       default: () => ({
//         duration: 500,
//       }),
//     },
//   },
// }

// const Wrapper = posed(NavWrapper)(config)
